// extracted by css-extract-rspack-plugin
export default {"container":"_f0a696fe"};